<template>
  <el-tabs
      v-model="activeTabMap"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adCampaign" lazy>
      <template #label>
        <span>广告活动</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countCampaign || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-campaign
          v-if="activeTabMap == 'adCampaign'"
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdCampaign"
      ></app-sp-ad-campaign>
    </el-tab-pane>
    <el-tab-pane name="adGroup" lazy>
      <template #label>
        <span>广告组</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countGroups || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-group
          v-if="activeTabMap == 'adGroup'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdGroup"
      ></app-sp-ad-group>
    </el-tab-pane>
    <el-tab-pane name="adProduct" lazy>
      <template #label>
        <span>广告</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countAds || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-product
          v-if="activeTabMap == 'adProduct'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdProduct"
      ></app-sp-ad-product>
    </el-tab-pane>
    <el-tab-pane name="adKeyword" lazy>
      <template #label>
        <span>关键词</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countKeywords || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-keyword
          v-if="activeTabMap == 'adKeyword'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdKeyword"
      ></app-sp-ad-keyword>
    </el-tab-pane>
    <el-tab-pane name="adNegKeyword" lazy>
      <template #label>
        <span>否定关键词</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeKeywords || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-neg-keyword
          v-if="activeTabMap == 'adNegKeyword'"
          manager-type="adManager"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdNegKeyword"
      ></app-sp-ad-neg-keyword>
    </el-tab-pane>
    <el-tab-pane name="adProductTarget" lazy>
      <template #label>
        <span>商品投放</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargeting || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-product-target
          v-if="activeTabMap == 'adProductTarget'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdProductTarget"
      ></app-sp-ad-product-target>
    </el-tab-pane>
    <el-tab-pane name="adNegTarget" lazy>
      <template #label>
        <span>否定商品投放</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeTargeting || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-neg-target
          v-if="activeTabMap == 'adNegTarget'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdNegTarget"
      ></app-sp-ad-neg-target>
    </el-tab-pane>
    <el-tab-pane name="adTargetGroup" lazy>
      <template #label>
        <span>投放组</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargetingGroups || 0"></gj-badge>
      </template>
      <div></div>
      <app-sp-ad-target
          v-if="activeTabMap == 'adTargetGroup'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdTargetGroup"
      ></app-sp-ad-target>
    </el-tab-pane>
    <el-tab-pane name="adSearchWord" lazy>
      <template #label>
        <span>用户搜索词</span>
      </template>
      <div></div>
      <app-sp-ad-search-keyword
          v-if="activeTabMap == 'adSearchWord'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="spAdSearchWord"
      ></app-sp-ad-search-keyword>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSpAdCampaign from "../components/ad-campaign/ad-campaign";
  import AppSpAdGroup from "../components/ad-group/ad-group";
  import AppSpAdProduct from "../components/ad-product/ad-product";
  import AppSpAdKeyword from "../components/ad-keyword/ad-keyword";
  import AppSpAdNegKeyword from "../components/ad-neg-keyword/ad-neg-keyword";
  import AppSpAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSpAdTarget from "../components/ad-target/ad-target";
  import AppSpAdSearchKeyword from "../components/ad-search-word/ad-search-word";
  import AppSpAdProductTarget from "../components/ad-product-target/ad-product-target";
  import {initDateMixin, inMarketMixin, inPortfolioMixin, tabResizeMixin} from "../../common/mixin";

  export default {
    name: "app-sp-ad-manager",
    components: {
      AppSpAdProductTarget,
      AppSpAdSearchKeyword, AppSpAdNegTarget,
      AppSpAdTarget, AppSpAdNegKeyword,
      AppSpAdKeyword, AppSpAdGroup,
      AppSpAdCampaign, AppSpAdProduct},
    mixins: [inMarketMixin, inPortfolioMixin, tabResizeMixin, initDateMixin],
    inject: ['cornerMarkerMap'],
    props: {
      activeTab: {
        type: String,
        default: 'adCampaign',
      }
    },
    data() {
      return {
        activeTabMap: "adCampaign",
        timeStamp:null
      }
    },
    computed: {
      cornerMarker() {
        return this.cornerMarkerMap()
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.timeStamp){
            this.activeTabMap = this.$route.query.activeTabMap;
            this.timeStamp = this.$route.query.timeStamp;
          }
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  // /deep/.fixed-left--wrapper.vxe-table--body-wrapper  {
  //   overflow-x: hidden !important;
  // }
  .ad-badge{
    margin-left: 4px;
    /deep/ .el-badge__content{
      font-weight: 600;
      font-family: PingFangSC-Semibold;
    }
  }
  .vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper{
    overflow-x: hidden;
  }
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
